import classNames from "classnames";

import styles from "./LikeButton.module.css";

type Props = {
  likes?: number;
  liked?: boolean;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
};

export const LikeButton = ({ likes = 0, liked, onClick }: Props) => {
  const tagClass = classNames(styles.tag);

  // LikeButton
  return (
    <button className={tagClass} onClick={onClick} data-active={liked}>
      <span>{likes}</span>
      <span>🤝</span>
    </button>
  );
};
